import React from 'react';

import { IBackendCart } from '@rbi-ctg/menu';
import { A11yWrapper } from 'components/a11y-wrapper';
import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import { GrandTotalLabel, Total, TotalsRow } from './styled';

const GrandTotalRow = TotalsRow.withConfig({
  marginTop: '$4',
});

interface GrandTotalProps {
  isLoading?: boolean;
  cart?: IBackendCart;
  serverOrderTip?: number;
  tipAmount: number;
}

const GrandTotal: React.FC<React.PropsWithChildren<GrandTotalProps>> = ({
  cart,
  serverOrderTip,
  tipAmount = 0,
  isLoading,
}) => {
  const { totalCents = 0 } = cart || {};
  const grandTotal = Math.max(totalCents - Number(serverOrderTip) + tipAmount, 0);

  return (
    <GrandTotalRow>
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <A11yWrapper>
            <GrandTotalLabel>{t('total')}</GrandTotalLabel>
          </A11yWrapper>
          <Total>
            <Currency
              testID="grand-total"
              amount={grandTotal > 0 ? grandTotal : 0}
              isBold
              textProps={{
                fontSize: 'md',
                color: getDesignToken('text-default'),
                style: { margin: 0, flexGrow: 0 },
              }}
            />
          </Total>
        </>
      )}
    </GrandTotalRow>
  );
};

export default GrandTotal;
